import React from 'react';
import { Card, Statistic, Typography } from 'antd';
import { RiseOutlined, FallOutlined } from '@ant-design/icons';
import { SEMANTIC, CARD_SHADOW } from '../../theme/statusColors.ts';

const { Text } = Typography;

interface KpiCardProps {
  title: string;
  value: number | null;
  prefix?: React.ReactNode;
  suffix?: string;
  precision?: number;
  deltaPct?: number | null;
  subText?: string;
  loading?: boolean;
  onClick?: () => void;
}

// Card KPI: Statistic con eventuale delta % (freccia su/giù colorata) e riga secondaria
const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  prefix,
  suffix,
  precision = 0,
  deltaPct,
  subText,
  loading,
  onClick,
}) => {
  const deltaColor = deltaPct != null && deltaPct >= 0 ? SEMANTIC.success : SEMANTIC.danger;

  return (
    <Card
      hoverable={!!onClick}
      size="small"
      onClick={onClick}
      loading={loading}
      style={{ boxShadow: CARD_SHADOW, height: '100%' }}
      styles={{ body: { padding: '12px 16px' } }}
    >
      <Statistic
        title={<Text type="secondary" style={{ fontSize: 12 }}>{title}</Text>}
        value={value != null ? value : '-'}
        prefix={prefix}
        suffix={suffix}
        precision={value != null ? precision : undefined}
        valueStyle={{ fontSize: 26, fontWeight: 600 }}
        decimalSeparator=","
        groupSeparator="."
      />
      <div style={{ marginTop: 4, minHeight: 18 }}>
        {deltaPct != null && (
          <Text style={{ fontSize: 12, color: deltaColor, marginRight: 8 }}>
            {deltaPct >= 0 ? <RiseOutlined /> : <FallOutlined />} {Math.abs(deltaPct).toLocaleString('it-IT')}%
          </Text>
        )}
        {subText && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            {subText}
          </Text>
        )}
      </div>
    </Card>
  );
};

export default KpiCard;
